"use client";
import { createContext, ReactNode } from "react";
import { useRedirectModal } from "../hooks/use-redirect-modal";

export interface RedirectModalContextType {
  isOpen: boolean;
  onClose: () => void;
  onOpen: () => void;
  saveCallback: (fn: Function, props: any) => void;
  runCallback: () => void;
}

export const RedirectModalContext = createContext<RedirectModalContextType>(
  // Necessary for type checking.
  // As per React docs, default not used when context is used with provider
  undefined as unknown as RedirectModalContextType,
);

export function RedirectModalProvider({ children }: { children: ReactNode }) {
  const value = useRedirectModal();

  return (
    <RedirectModalContext.Provider value={value}>
      {children}
    </RedirectModalContext.Provider>
  );
}
